import { useState } from 'react'
import CloseIcon from '../../../assets/CloseIcon'
import SearchIcon from '../../../assets/SearchIcon'

const ProductReceivingFilter = ({ filterOptions, setFilterOptions }) => {
  const [searchTerm, setSearchTerm] = useState(filterOptions?.search || '')

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    setFilterOptions({ search: searchTerm })
  }

  const handleClearSearch = (e) => {
    e.preventDefault()
    if (!searchTerm) return
    setSearchTerm('')
    setFilterOptions({ search: '' })
  }

  return (
    <div className="dFlex mt-5 gap-7">
      <div className="formGroup mb-0 searchBar expand">
        <form onSubmit={handleSearchSubmit}>
          <input
            type="text"
            className="formControl"
            value={searchTerm}
            placeholder="Search By Invoice Number"
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearchSubmit(e)
              }
            }}
          />
        </form>

        <div className="searchIcon" onClick={handleSearchSubmit}>
          <SearchIcon />
        </div>

        <div className="closeIcon" onClick={handleClearSearch}>
          <CloseIcon />
        </div>
      </div>
    </div>
  )
}

export default ProductReceivingFilter
